
import { ChevronBackOutline } from "react-ionicons"
import Logo from "../../assets/images/Logo.png"
import { useSearchParams, useLocation, useNavigate } from "react-router-dom"
import BackBtn from "../../Components/BackBtn/BackBtn"
import { FailedPopup, FormValidation, customLogger, successPopup } from "../../common/Utils/Utils"
import { useCallback, useEffect, useState } from "react"
import moment from "moment"
import { ManageApis } from "../../common/APIS/ManageApis"
import InputField from "../../Components/InputField/InputField"
import VerifyOTP from "../VerifyOTPScreen/VerifyOTP"
import LoginRegLayout from "../UserLoginReg/LoginReg"
import { Divider } from "@arco-design/web-react"

function UnregisteredUserAuth() {
   const [searchParams] = useSearchParams();
	//debugger
	const InitialValue = {
		mobile: "",
		dob: ""
	}

	const navigate = useNavigate()
	const { pathname } = useLocation()
	const [form, setform] = useState({
		mobile: "",
	})
	const [formItem, setformItem] = useState({
		mobile: "",
	})
	const [verificationData, setverificationData] = useState()
	const [Otp, setOtp] = useState('')
	const [Errors, setErrors] = useState([])
	const [IsLoading, setIsLoading] = useState(false)
	const [showCaptcha,setshowCaptcha]=useState(false)
  const linkDetails = JSON.parse(localStorage.getItem("linkDetails"))
  const localreqbody = localStorage.getItem("reqbody") ? JSON.parse(localStorage.getItem("reqbody")) : ""
  const [reqbody,setReqbody] = useState(localreqbody || {
    mode:'mobile',
    mobile:'',
    email:'',
  })

  const nextPath = searchParams.get("next") || "/quickpay"; // fallback

	useEffect(() => {
		localStorage.setItem("reqbody", JSON.stringify(reqbody))
	}, [reqbody])

	useEffect(() => {
		const storedReqbody = JSON.parse(localStorage.getItem("reqbody")) || []
		setReqbody(storedReqbody)
	}, [])

  useEffect(()=>{
    if((pathname.includes("/verifyotp") || localStorage.getItem("quickToken")) && !verificationData){
      if(nextPath?.includes("/newchits")){
        navigate('/quick-verify?next=/newchits')
      }else{
        navigate('/quick-verify')
      }
    }
    localStorage.removeItem("quickToken");
  },[pathname])

	const handleChange = useCallback((value, name) => {
		customLogger(({ value, name }))
		setReqbody(prev => ({ ...prev, [name]: value }))
	}, [])

	const formField = [
		{ type: 'mobile', label: 'Mobile', placeholder: '', required: true, onchange: handleChange, name: 'mobile', disabled: false, value:reqbody.mobile },
		{ type: 'email', label: 'Email', placeholder: '', required: true, onchange: handleChange, name: 'email', disabled: false, value:reqbody.email },
	]
	const validate = () => Errors.some(item => item?.message)

	const handleSubmit = async () => {
    const requiredItems = formField
      .filter((item) => item.required) // Get only required fields
      .map((item) => item.name) // Extract field names
      .filter((name) =>
        reqbody.mode === "mobile" ? name === "mobile" : name === "email"
      ); // Ensure only relevant field is validated

    const validationResult = FormValidation(reqbody, requiredItems);

    if (validationResult.validation) {
      // trigger check username api
      if (!validate()) {
        handleCallApi();
      }
    } else {
      if (validationResult.failedItems.length) {
        let requiredItems = formField.map((item) => ({
          name: item.name,
          message: validationResult.failedItems.includes(item.name)
            ? "Field is required"
            : "",
        }));
        if (!Errors.length) {
          setErrors(requiredItems);
        } else {
          setErrors((prev) => [...prev, ...requiredItems]);
        }
      }
    }
  };

  const handleCallApi = async () => {
    setIsLoading(true);
    try {
      const response = await ManageApis("post", global.quickpayOTP, reqbody);

      if (response.message === "Success") {
        const { token_alphabet_part, masked_data } =
          response.response_data.data || {};

        if (token_alphabet_part && masked_data) {
          const verification = { token_alphabet_part, masked_data };
          localStorage.setItem('verificationData', JSON.stringify(verification))
          localStorage.setItem('reqbody', JSON.stringify(reqbody))
          setverificationData(verification);
          setErrors([]);
          nextPath == "/newchits" ? 
          navigate(`/quick-verify/verifyotp?next=${nextPath}`, {
            state: { reqbody, is_unregistered: true },
          })
          : 
          navigate(`/quick-verify/verifyotp`, {
            state: { reqbody, is_unregistered: true },
          })

          
          successPopup(response.response_data.message);
        } else {
          FailedPopup(response);
        }
      } else {
        FailedPopup(response);
      }

      setIsLoading(false);
    } catch (error) {
      console.log("error->", error);
      setIsLoading(false);
    }
  };

	const handleErrors = (name, message) => {
		customLogger(name, message)
		if (Errors.length) {
			setErrors(Errors.map(item => item.name === name ? { name: name, message } : item))
		} else
			setErrors(prev => [...prev, { name: name, message }])

	}

	// resend otp
	const handleResendOTP = async () => {
		setOtp('')
		setIsLoading(true);
		try {
			const response = await ManageApis("post", global.quickpayResend, reqbody);
			if (response.message === "Success") {
				const { token_alphabet_part } = response.response_data.data || {};
				if (token_alphabet_part) {
					setverificationData(prev => ({ ...prev, token_alphabet_part }));
          let currentVerificationData = JSON.parse(localStorage.getItem('verificationData')) || {};
          currentVerificationData.token_alphabet_part = token_alphabet_part;
          localStorage.setItem('verificationData', JSON.stringify(currentVerificationData));
					successPopup(response.response_data.message);
				} else {
					FailedPopup(response);
				}
			} else {
				FailedPopup(response);
			}
		} catch (error) {
			console.log("error->", error);
		} finally {
			setIsLoading(false);
		}
	};

	// handle varify OTP
	const handleOtpVerification = async (Otp) => {
    setIsLoading(true)
		const rqstBody = {
			...reqbody,
			otp: `${verificationData.token_alphabet_part}${Otp}`,
		};
		//debugger
		try {
			// axios call for verify mobile
			let response = await ManageApis("post", global.quickpayVerify, rqstBody);
			// if axios call success for verify mobile
			if (response.message == "Success") {
        setIsLoading(false)
        const token = response.response_data.data.token
        localStorage.setItem("quickToken",token)
        localStorage.removeItem("reqbody");
        localStorage.removeItem("verificationData");
				navigate(nextPath, { state: { is_unregister_user: true }, replace: true })
				successPopup(response)
			} else {
        setIsLoading(false)
				FailedPopup(response);
				setshowCaptcha(false)
			}
		} catch (error) {
      setIsLoading(false)
			console.log("error->", error);
			setshowCaptcha(false)
		}
	};

	const handleCaptcha=(otp)=>{
		setshowCaptcha(false)
		handleOtpVerification(otp)
	}

  const handleModeSwitch = () => {
    if (reqbody.mode === "mobile") {
      setReqbody(prev => ({...prev, mobile: "", mode: "email"}));
    } else {
      setReqbody(prev => ({...prev, email: "", mode: "mobile"}));
    }
    setErrors([])
  }

  const linkOTPCall = async () => {
    setIsLoading(true)
    try {
      let linkReqBody = {
        mode: "mobile",
        mobile: linkDetails.mobileNumber,
        email: "",
      };
      const response = await ManageApis(
        "post",
        global.quickpayOTP,
        linkReqBody
      );

      if (response.message === "Success") {
        const { token_alphabet_part, masked_data } =
          response.response_data.data || {};

        if (token_alphabet_part && masked_data) {
          setIsLoading(false)
          const verification = { token_alphabet_part, masked_data };
          localStorage.setItem('verificationData', JSON.stringify(verification))
          localStorage.setItem('reqbody', JSON.stringify(reqbody))
          setverificationData(verification);
          setReqbody(linkReqBody);
          setErrors([]);
          navigate("/quick-verify/verifyotp", {
            state: { reqbody, is_unregistered: true },
          });
          successPopup(response.response_data.message);
        } else {
          setIsLoading(false)
          FailedPopup(response);
        }
      } else {
        setIsLoading(false)
        FailedPopup(response);
      }

      setIsLoading(false);
    } catch (error) {
      console.log("error->", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if(linkDetails){
      linkOTPCall()
    }
  },[])

  const handleBackBtn = () => {
      if (window.history.state?.idx === 0 || window.history.state === null) {
        navigate("/");
      } else navigate(-1);
      localStorage.removeItem("reqbody")
      localStorage.removeItem("verificationData");
  }

  const handleBackBtnMobilePage = () => {
    navigate('/login')
    localStorage.removeItem("reqbody")
    localStorage.removeItem("verificationData");
}


	if (pathname.includes("/verifyotp")) {
    return (
      <LoginRegLayout loading={IsLoading}>
        <VerifyOTP
          verificationData={verificationData}
          setVerificationData={setverificationData}
          handleResendOTP={handleResendOTP}
          value={Otp}
          handleBackBtn={handleBackBtn}
          handleSubmit={handleCaptcha}
          showCaptcha={showCaptcha}
          setshowCaptcha={setshowCaptcha}
          isCaptcha={false}
        />
      </LoginRegLayout>
    );
  } else {
    return (
      <LoginRegLayout loading={IsLoading}>
        <div className="d-flex flex-column h-100 p-5 overflow-auto scrollbar1">
          <div className="">
            <div className="round_sm d-flex bg_gray2 rounded-circle cursor-pointer d-inline-flex px_hover_1">
              <BackBtn handleBackBtn={handleBackBtnMobilePage}/>
            </div>
          </div>
          <div className="m-auto max_w_350x py-3 w-100">
            <div>
              <div className="text-center">
                <img src={Logo} className="mb-4 logo_prop" />
              </div>
              <h1 className="h6 text-center text_master fw_600 pb-3 mx-5">
                {reqbody.mode === "mobile" ? "Enter your mobile number to receive the OTP" : "Enter your email to receive the OTP"}
              </h1>
              {formField
                .filter(
                  (item) =>
                    (reqbody.mode === "mobile" && item.name === "mobile") ||
                    (reqbody.mode !== "mobile"  && item.name === "email")
                )
                .map((item) => (
                  <div key={item.name}>
                  <InputField
                    {...item}
                    errorMessage={
                      !!Errors.length &&
                      Errors?.find((itm) => itm.name == item.name)?.message
                    }
                    seterrorMessage={handleErrors}
                    />
                    </div>
                ))}
              <div>
                <button
                  // disabled={validate}
                  type="submit"
                  className="btn px_btn btn-master px-4 rounded w-100 fw_500"
                  onClick={handleSubmit}
                >
                  Verify {reqbody.mode === "mobile"  ? "Mobile Number" : "Email"}
                </button>
              </div>
              <Divider orientation={"center"}>Or</Divider>
              <div>
                <button
                  type="submit"
                  className="btn px_btn btn-master-line px-4 rounded w-100 fw_500"
                  onClick={handleModeSwitch}
                >
                  <i className={` ${reqbody.mode !== "mobile"  ? `fas fa-phone` : 'far fa-envelope' }`}></i> Continue with{" "}
                  {reqbody.mode !== "mobile"  ? "Mobile Number" : "Email"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </LoginRegLayout>
    );
  }

}
export default UnregisteredUserAuth

